module.exports = __webpack_public_path__ + "2828ca97e06590d2f8efa5af2c57aa24.png";